export interface ApiResponse<T = any> {
  errorCode?: string
  errorMessage?: string
  isError: boolean
  object: T
  error?: boolean
  isOk?: boolean
  status?: number | string
  statusCode?: number
  /** Cờ phân quyền nút bấm — chưa xác nhận BE có đính kèm ở mọi endpoint chi tiết (không phân trang)
   * hay chỉ ở danh sách (xem PagedObject.buttonShow). Khai báo optional để dùng được khi có. */
  buttonShow?: ButtonShow
}

/**
 * BSSA.Result không có field errorMessage — text lỗi đi trong `object` dạng string
 * (ResultLib/Extensions/ErrorOrIntegration.cs: message.ToResultError_User()).
 * Dùng helper này ở mọi mutation hook thay cho `res.errorMessage` trực tiếp.
 */
/** BE rò marker nội bộ `[MessageForUser]` ra client, có lúc lặp 2 lần — bóc sạch.
 * Đo thật 2026-08-24: object = "[MessageForUser] [MessageForUser] Tài khoản hoặc mật khẩu không chính xác".
 * Đã báo BE sửa gốc; giữ lớp phòng vệ này cho tới khi BE sạch. */
const stripInternalMarker = (text: string): string =>
  text.replace(/^(\s*\[MessageForUser\]\s*)+/, '').trim()

export const getErrorMessage = (res?: Partial<ApiResponse>, fallback = 'Lỗi từ server'): string => {
  if (!res) return fallback
  if (typeof res.errorMessage === 'string' && res.errorMessage.trim())
    return stripInternalMarker(res.errorMessage) || fallback
  if (typeof res.object === 'string' && res.object.trim())
    return stripInternalMarker(res.object) || fallback
  return fallback
}

/** Khớp ResultLib/Models/Pagination.cs — PagedResponse<T> */
export interface PagedObject<T> {
  items: T
  page: number
  pageSize: number
  totalItems: number
  totalPages: number
  hasPreviousPage?: boolean
  hasNextPage?: boolean
  /** Cờ phân quyền nút bấm của category tương ứng — không phải màn nào cũng nhúng (xem BE Service.GetListAsync). */
  buttonShow?: ButtonShow
}

export interface ApiPaginationResponse<T = unknown> extends ApiResponse {
  object: PagedObject<T>
}

/** Khớp VBDT/DTOs/Role/RoleDTOs.cs — ButtonShowResult (camelCase trên dây) */
export interface ButtonShow {
  isVisitTab: boolean
  isInsert: boolean
  isUpdate: boolean
  isDelete: boolean
  isExport: boolean
  isLock: boolean
  /** Tuỳ chọn: BE cũ / fixture cũ chưa có cờ này → mapPermission coi là false */
  isForceLogout?: boolean
  /** Tuỳ chọn: quyền từ chối ký (document-sign). BE cũ / fixture cũ chưa có → coi là false */
  isReject?: boolean
  isResetPass: boolean
  isApprove: boolean
  isDataGlobal: boolean
  isSubmit: boolean
}
